import script from "./btnAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./btnAnimation.vue?vue&type=script&setup=true&lang=js"

import "./btnAnimation.vue?vue&type=style&index=0&id=10420810&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10420810"]])

export default __exports__